<template>
  <page-list
    :list="list"
    :columns="columns"
    :export-data-options="exportDataOptions"
    :singleActions="singleActions"
    :groupActions="groupActions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'BillPredictImportList',
  components: {
  },
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
  },
  data () {
    return {
      dateMode: 'month',
      dateParam: {},
      showBillAccounts: true,
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'predict_params',
        apiVersion: 'v1',
        idKey: 'day',
        getParams: this.getParam,
        noPreLoad: true,
        // filterOptions: {
        //   name: {
        //     label: this.$t('table.title.name'),
        //     filter: true,
        //     formatter: val => {
        //       return `name.contains('${val}')`
        //     },
        //   },
        //   brand: getBillBrandFilter(),
        //   currency: getDistinctFieldFilter({ label: this.$t('bill.currency_bill'), field: 'currency' }),
        // },
      }),
      columns: [
        {
          field: 'day',
          label: this.$t('bill.date'),
          formatter: ({ row }) => {
            const str = row.day + ''
            return `${str.substr(0, 4)}-${str.substr(4, 2)}-${str.substr(6, 2)}`
          },
        },
        {
          field: 'value1',
          label: this.$t('bill.num_value'),
          slots: {
            default: ({ row }, h) => {
              return [
                h('list-body-cell-wrap', {
                  props: {
                    label: this.$t('bill.num_value'),
                    resource: 'predict_params',
                    row: row,
                    onManager: this.onManager,
                    edit: true,
                    copy: false,
                    field: 'value1',
                    overflow: 'wrap',
                    inputType: 'inputNumber',
                    formRules: [{ required: false, message: this.$t('common.tips.input', [this.$t('bill.num_value')]) }],
                    ok: (value) => {
                      this.updateData(row, 'value1', value)
                    },
                  },
                }),
              ]
            },
          },
          needExportFormat: true,
        },
      ],
      groupActions: [
        {
          label: this.$t('bill.import'),
          // permission: 'users_create',
          action: () => {
            this.createDialog('PredictDataImprotDialog', {
              ok: () => {
                this.fetchData()
              },
            })
          },
          meta: () => {
            const ret = {
              buttonType: 'primary',
            }
            return ret
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.$t('bill.text_244'),
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    async updateData (row, field, value) {
      try {
        await new this.$Manager('predict_params/upload', 'v1').create({
          data: [{
            day: row.day,
            values: [value],
          }],
        })
        this.list.refresh()
      } catch (err) { throw err }
    },
    getParam () {
      const ret = {
      }
      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row, tab) {
      this.sidePageTriggerHandle(this, 'BillAccountSidePage', {
        id: row.id,
        resource: row.id === 'yunion' ? () => {
          return {
            data: row,
          }
        } : 'meter_cloudaccounts',
        data: row,
        getParams: { ...this.getParams, account_id: row.id },
        dateParam: this.dateParam,
        dateMode: this.dateMode,
      }, {
        list: this.list,
        tab,
      })
    },
  },
}
</script>
